import { render, staticRenderFns } from "./CBoardLeftTrigger.vue?vue&type=template&id=10019908&scoped=true&"
import script from "./CBoardLeftTrigger.vue?vue&type=script&lang=ts&"
export * from "./CBoardLeftTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./CBoardLeftTrigger.vue?vue&type=style&index=0&id=10019908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10019908",
  null
  
)

export default component.exports